import { defineMessages } from 'react-intl';

export default defineMessages({
    primary: {
        id: 'quoteandbind.ho.views.ho-package-details.Primary',
        defaultMessage: 'Primary',
    },
    packageType: {
        id: 'quoteandbind.ho.views.ho-package-details.Package Type',
        defaultMessage: 'Package Type',
    },
    locationType: {
        id: 'quoteandbind.ho.views.ho-package-details.Coverage Form',
        defaultMessage: 'Coverage Form',
    },
    addPackageDetails: {
        id:'quoteandbind.ho.views.ho-package-details.Add Package Details',
        defaultMessage:'Add Package Details'
    },
    addAnotherPackageDetails: {
        id:'quoteandbind.ho.views.ho-package-details.Add Another Package Details?',
        defaultMessage:'Add Another Package Details?'
    },
    packageDetailsForThisHome: {
        id:'quoteandbind.ho.views.ho-package-details.Package Details for This Home',
        defaultMessage:'Package Details for This Home'
    },

    packageDetails: {
        id:'quoteandbind.ho.views.ho-package-details.Package Details:',
        defaultMessage:'Package Details:'

    }


});
